export default {
    home: {
        title: "",
        access: "Acceder"  
    },
    login: {
        header: {
            title: '',
        },
        form: {
            'reset-password': "Resetear contraseña",
            'login': "login"
        }
    },
    layout: {
        account: {
            subtitle: "admin",
            logout: "Logout"
        }
    }
}